<template>
  <div class="smallbanner">
    <div class="swiper-pagination"></div>
    <swiper :options="swiperOption" ref="smallSwiper">
      <swiper-slide v-for="item in banner" :key="item.ID" v-lazy-container="{ selector: 'img' }">
        <img :src="'http://donghao.chinadonghao.com/upload/'+item.BIGURL" :data-src="`http://donghao.chinadonghao.com/upload/${item.BIGURL}`" :data-loading="`http://donghao.chinadonghao.com/upload/${item.PICURL}`" alt>
        <div class="text">
          <div class="title1" :class="showup" v-html="item.EN"></div>
          <div class="title2" :class="showup" v-text="item.PICNAME"></div>
          <div class="link" :class="showup">entorprise video
            <i class="el-icon-caret-right"></i>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
// @ is an alias to /src
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "./jquery-1.11.3.min.js";
import { mapState } from 'vuex'
import { getPicUrl } from '@/util/lang.js'

export default {
  name: "Swiper",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".smallbanner .swiper-pagination",
          clickable: true,
          renderBullet: function(index, className) {
            return '<span class="' + className + '"><i></i></span>';
          }
        },
        notNextTick: true,
        loop: true,
        init: false,
        //observer: true,
        //observeParents: true,
        //observeSlideChildren: true,
        autoplay:{
          disableOnInteraction: false,
          delay: 5000
        },
        on: {
          slideChangeTransitionEnd: () => {
            this.$nextTick(() => {
              let swiper = this.$refs.smallSwiper.swiper;
              let active = swiper.realIndex;
              let previousIndex = swiper.previousIndex;
              let bullets = swiper.pagination.bullets;
              let bulletsArray = Array.from(bullets);

                for (let i = 0; i < bulletsArray.length; i++) {
                  $('.smallbanner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().width("0%")
                }
                for (let i = 0; i < active; i++) {
                  $('.smallbanner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().width("100%")
                }
                $('.smallbanner .swiper-pagination .swiper-pagination-bullet').eq(active).children('i').stop().animate({width: '100%'}, 5000, "linear")

                
              
            });
          }
        }
      },
      showup: "",
      banner: []
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  watch: {
    lang: 'fetchDate'
  },
  mounted () {
    this.fetchDate(this.lang)
  },
  methods: {
    fetchDate (val) {
      if (val) {
        const url = getPicUrl(this.lang, '手机首页banner', '10')
        this.$$axios.get(url).then(res => {
          this.banner = res.data
          this.banner.map((item)=>{
            item.EN=item.EN.replace(/\n/g, "<br>")
          })
          this.$nextTick(()=>{
            this.$refs.smallSwiper.swiper.init()
          })
          
        }).then(()=>{
          this.$emit('wow')
        })
      }
    }
  }
};
</script>

<style>
.smallbanner {
  position: relative;
}
.smallbanner img {
  width: 100%;
  display: block;
}
.smallbanner .swiper-pagination {
  bottom: 5%;
  width: 100%;
}
.smallbanner .swiper-pagination .swiper-pagination-bullet {
  position: relative;
  width: 65px;
  height: 4px;
  border: 1px solid #fff;
  border-radius: 0;
  opacity: 0.6;
  margin: 0 5px;
  background-color: transparent;
}
.smallbanner .swiper-pagination .swiper-pagination-bullet:focus{
  outline: none;
}
.smallbanner .swiper-pagination .swiper-pagination-bullet i{
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: #fff;
  opacity: 0.6;
}

.smallbanner .text {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1500px;
  max-width: 100%;
  transform: translate(-50%, -50%);
  color: #fff;
  padding: 0 4.7%;
  text-shadow: 2px 2px 6px rgba(0,0,0,.8);
}
.smallbanner .text .title1 {
  font-size: 50px;
  text-transform: uppercase;
  transition: 2s;
  opacity: 0;
  transform: translateY(100%);
  font-family: dinengschrift;
}
.smallbanner .text .title1 p {
  margin: 0;
}
.smallbanner .text .title2 {
  font-size: 35px;
  transition: 2s 0.5s;
  opacity: 0;
  transform: translateY(100%);
  margin-top: 30px;
}
.smallbanner .text .link {
  font-size: 12px;
  text-transform: uppercase;
  transition: 2s 1s;
  opacity: 0;
  transform: translateY(100%);
  cursor: pointer;
  margin-top: 40px;
}
.smallbanner .text .link i {
  border: 1px solid;
  border-radius: 50%;
  font-size: 24px;
  vertical-align: middle;
  margin-left: 10px;
}
/* .banner .text .showup {
  opacity: 1;
  transform: translateY(0);
} */
.smallbanner .swiper-slide-active .text .title1,
.smallbanner .swiper-slide-active .text .title2,
.smallbanner .swiper-slide-active .text .link {
  opacity: 1;
  transform: translateY(0);
}
@media (max-width: 768px){
  .smallbanner .text .title1{
    font-size: 24px;
  }
  .smallbanner .text .title2{
    font-size: 16px;
    margin-top: 15px;
  }
  .smallbanner .text .link{
    font-size: 12px;
    margin-top: 15px;
  }
  .smallbanner .text .link i{
    font-size: 14px;
  }
}
</style>

